module.exports = __webpack_public_path__ + "media/images/icons/icn_043-4e63be7aa3702c08e12ecda0730aa845.svg";